const diningLivingSlide = (() => {

  const pageOutdoorDining = document.getElementById('pageOutdoor-dining');
  const pageWellnessLiving = document.getElementById('pageWellness-living');
  if ((pageOutdoorDining) || (pageWellnessLiving)) {

    let setslidesPerView
    if (pageOutdoorDining) {
      setslidesPerView = 6
    } else {
      setslidesPerView = 5
    }

    //サムネイル
    const sliderThumbnail = new Swiper('.swiper-thumbnail', {
      slidesPerView: setslidesPerView,
      freeMode: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
    });


    //スライダー
    const swiper = new Swiper(".swiper", {
      slidesPerView: 1,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      thumbs: {
        swiper: sliderThumbnail
      },
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      effect: 'fade',
      speed: 1000,
    });

    // console.log("object");
  }
})();
export default diningLivingSlide;